export const getErrorMessage = (errorData) => {
  let errorMessage = "An unexpected error occurred";

  // Check for validation errors
  if (errorData?.errors) {
    // If there are multiple errors, join them into a single string
    const errorMessages = errorData.errors
      .map((error) => `${error.field}: ${error.message}`)
      .join(", ");
    errorMessage = errorMessages;
  }
  // Check for a general error message
  else if (errorData?.message) {
    errorMessage = errorData.message;
  }

  return errorMessage;
};

